import {KeyValue} from '../../../../common/arr-transfer-list/ArrTransferList';

export const METADATA_FIELD_OPTIONS: KeyValue[] = [
  {id: 1, label: 'Document Title', dataType: 'string'},
  {id: 2, label: 'Author', dataType: 'string'},
  {id: 3, label: 'Created Date', dataType: 'date'},
  {id: 4, label: 'Department', dataType: 'string'},
  {id: 5, label: 'Category', dataType: 'string'},
  {id: 6, label: 'File Type', dataType: 'string'},
  {id: 7, label: 'Last Modified Date', dataType: 'date'},
  {id: 8, label: 'Modified By', dataType: 'string'},
  {id: 9, label: 'Version Number', dataType: 'number'},
  {id: 10, label: 'Document ID', dataType: 'string'},
  {id: 11, label: 'Review Status', dataType: 'string'},
  {id: 12, label: 'Approval Date', dataType: 'date'},
  {id: 13, label: 'Approved By', dataType: 'string'},
  {id: 14, label: 'Confidentiality Level', dataType: 'string'},
  {id: 15, label: 'Retention Period', dataType: 'number'},
  {id: 16, label: 'Tags', dataType: 'string'},
  {id: 17, label: 'File Size', dataType: 'number'},
  {id: 18, label: 'Checksum', dataType: 'string'},
  {id: 19, label: 'Language', dataType: 'string'},
  {id: 20, label: 'Source System', dataType: 'string'},
  {id: 21, label: 'Record Type', dataType: 'string'},
  {id: 22, label: 'Document Owner', dataType: 'string'},
  {id: 23, label: 'Storage Location', dataType: 'string'},
  {id: 24, label: 'Expiry Date', dataType: 'date'},
  {id: 25, label: 'Review Frequency', dataType: 'number'},
  {id: 26, label: 'Indexing Status', dataType: 'string'},
  {id: 27, label: 'Template Type', dataType: 'string'},
  {id: 28, label: 'Priority Level', dataType: 'string'},
  {id: 29, label: 'Project Name', dataType: 'string'},
  {id: 30, label: 'Business Unit', dataType: 'string'},
  {id: 31, label: 'Legal Entity', dataType: 'string'},
  {id: 32, label: 'Country', dataType: 'string'},
  {id: 33, label: 'Contract Number', dataType: 'string'},
  {id: 34, label: 'Reviewer Comments', dataType: 'string'},
  {id: 35, label: 'Internal Notes', dataType: 'string'},
  {id: 36, label: 'Archive Status', dataType: 'string'},
];
